import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards from "@/components/service/ServiceCards";
import FencingQuoteForm from "./sections/FencingQuoteForm";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import { House, Layers, Sparkles, CloudRain, ShieldCheck, BrickWall } from "lucide-react";
const fencingCards = [{
  title: "Custom Wood Fencing",
  description: "Expertly crafted timber solutions that provide natural beauty and robust boundary security for your garden and perimeter in Southampton, Hampshire & surrounding areas.",
  icon: House
}, {
  title: "Security Panel Systems",
  description: "High-durability composite and reinforced timber panels designed to protect your Southampton home while maintaining a clean, modern aesthetic.",
  icon: Layers
}, {
  title: "Decorative Garden Gates",
  description: "Bespoke entrance gates that combine secure latching and access with crafted details to complement your Southampton landscaping.",
  icon: Sparkles
}, {
  title: "Weather-Resistant Solutions",
  description: "Pressure-treated timber, heavy-duty gravel boards, and rot-resistant treatments designed to endure coastal Hampshire wind and rain.",
  icon: CloudRain
}, {
  title: "Privacy Screening",
  description: "Strategic fencing designs focused on creating private outdoor spaces, reducing road noise and shielding Southampton properties effectively.",
  icon: ShieldCheck
}, {
  title: "Boundary Wall Integration",
  description: "Seamless blending of existing brickwork with precision-installed fence panels for a sturdy, attractive property border across Southampton.",
  icon: BrickWall
}];
export default function FencingPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="Fencing" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="Fencing in Southampton" intro="Professional fencing installations and repairs tailored to your Southampton property. We supply and erect durable, weather-tested boundaries that enhance security and kerb appeal across Southampton, Hampshire & surrounding areas." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/premium_timber_fencing_uk.png" imageAlt="Quality timber fencing installation in Southampton by Firststop Roofing Ltd" actions={true} />

      <ServiceIntro eyebrow="EXPERT BOUNDARIES & TIMBERWORK" heading="Professional Fencing & Boundary Solutions in Southampton" paragraphs={["Firststop Roofing Ltd delivers reliable fencing installations, replacements, and storm repairs for homeowners across Southampton, Hampshire & surrounding areas. As trusted roofing and exterior property specialists, we build solid, attractive boundaries engineered to withstand coastal weather conditions.", "From traditional closeboard and feather-edge panels to contemporary slatted screens and secure garden gates, Matt and the team supply and install robust fencing built on deep-set concrete or pressure-treated timber posts."]} benefits={["High-grade pressure-treated timber, composite panels, and concrete gravel boards", "Deep-set posts anchored in concrete to withstand strong coastal Hampshire winds", "Bespoke garden gates, storm damage replacements, and boundary wall integration"]} imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/premium_timber_fencing_uk.png" imageAlt="Closeboard timber fence and concrete posts installed in Southampton" cta={true} />

      <ServiceCards eyebrow="WHAT WE OFFER" heading="Our Fencing Services in Southampton" intro="Explore our comprehensive range of timber and panel fencing solutions, installed by local roofing and property specialists to secure and elevate homes across Southampton and nearby Hampshire towns." items={fencingCards} columns={3} />

      <FencingQuoteForm />

      <OtherServices currentKey="fencing" />

      <CtaBand />

      <Footer />
    </div>;
}